// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + (chunkId === 9765 ? "crm" : chunkId) + "." + {"8656":"c49d5d61","9585":"3b53517f","9765":"a0906bdf"}[chunkId] + ".chunk.css");